module.exports = __webpack_public_path__ + "img/advantage8.18c81b92.png";